import { Component, Input } from '@angular/core'
import { AbstractControl, FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { EluxIcon } from '@elxjs/ui'

@Component({
  selector: 'app-system-input-error',
  standalone: true,
  imports: [CommonModule, FormsModule, EluxIcon],
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
})
export class InputErrorComponent {
  @Input() id: string = ''
  @Input() field: AbstractControl | null | undefined = null
  @Input() custom: boolean = false
  @Input() customError: string = ''
}
